import HeroSection from "./components/HeroSection";
import ContactInfoSection from "./components/ContactInfoSection";
import FormSection from "./components/FormSection";
import PrepSection from "./components/PrepSection";
import FaqSection from "./components/FaqSection";
import FinalCtaSection from "./components/FinalCtaSection";
import SEOMeta from "@/components/feature/SEOMeta";

const siteUrl = (typeof import.meta !== "undefined" && import.meta.env?.VITE_SITE_URL) || "https://chronosspace.com";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "聯繫我們｜速築美宅家 Chronos Space",
  "description": "留下你的自地自建需求與聯絡方式，包含基地位置、預算級距、期望時程與生活場景。速築美宅家 Chronos Space 將協助你評估下一步。",
  "url": `${siteUrl}/contact`,
  "about": {
    "@type": "Organization",
    "name": "速築美宅家 Chronos Space",
    "url": siteUrl,
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "availableLanguage": "Chinese"
    }
  }
};

export default function Contact() {
  return (
    <div className="pt-16 md:pt-20">
      <SEOMeta
        title="聯繫我們"
        description="留下你的自地自建需求與聯絡方式，包含基地位置、預算級距、期望時程與生活場景。速築美宅家 Chronos Space 將協助你評估下一步。"
        keywords="聯繫我們,線上諮詢,自地自建諮詢,LINE@諮詢,建築設計諮詢"
        canonicalPath="/contact"
        jsonLd={jsonLd}
      />

      <HeroSection />
      <ContactInfoSection />
      <FormSection />
      <PrepSection />
      <FaqSection />
      <FinalCtaSection />
    </div>
  );
}